import type { Credential } from "@client/models";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const credentialsEntityAdapter = createEntityAdapter<Credential>({
    sortComparer: (a, b) => a.name.localeCompare(b.name),
});